var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { saveAs } from 'file-saver';
import services from '../../services';
import { getNameFromProvisioningProfile } from './helpers';
var SubdomainService = services.SubdomainService, PublicationService = services.PublicationService, AccountsService = services.AccountsService, BundleService = services.BundleService;
export var fetchLatestWebPublication = function (appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var object, _a, name_1, _b, icon, data, bgColor, textColor, e_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    dispatch({ type: 'PLATFORM_WEB_PUBLICATION_REQUEST' });
                    return [4 /*yield*/, PublicationService.getPublicationWebLatest(appId)];
                case 1:
                    object = (_c.sent()).object;
                    if (object) {
                        _a = object.app_name, name_1 = _a === void 0 ? null : _a, _b = object.app_icon, icon = _b === void 0 ? null : _b, data = object.data;
                        bgColor = void 0, textColor = void 0;
                        if (data) {
                            bgColor = data.background_color || '#FFFFFF';
                            textColor = data.text_color || '#828282';
                        }
                        dispatch({
                            type: 'PLATFORM_WEB_PUBLICATION_SUCCESS',
                            name: name_1,
                            icon: icon,
                            bgColor: bgColor,
                            textColor: textColor,
                        });
                        return [2 /*return*/, { name: name_1, icon: icon, bgColor: bgColor, textColor: textColor }];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _c.sent();
                    console.error(e_1);
                    return [3 /*break*/, 3];
                case 3:
                    dispatch({ type: 'PLATFORM_WEB_PUBLICATION_FAILURE' });
                    return [2 /*return*/, { name: null, icon: null, bgColor: '#FFFFFF', textColor: '#828282' }];
            }
        });
    }); };
};
export var createWebPublication = function (appId, publication, platform) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var name_2, icon, _a, text_color, background_color, e_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    dispatch({ type: 'PLATFORM_WEB_PUBLICATION_REQUEST' });
                    return [4 /*yield*/, PublicationService.createPublication(appId, publication, platform)];
                case 1:
                    _b.sent();
                    name_2 = publication.app_name, icon = publication.app_icon, _a = publication.data, text_color = _a.text_color, background_color = _a.background_color;
                    dispatch({
                        type: 'PLATFORM_WEB_PUBLICATION_SUCCESS',
                        name: name_2,
                        icon: icon,
                        text_color: text_color,
                        background_color: background_color,
                    });
                    return [2 /*return*/, { name: name_2, icon: icon, textColor: text_color, bgColor: background_color }];
                case 2:
                    e_2 = _b.sent();
                    console.error(e_2);
                    return [3 /*break*/, 3];
                case 3:
                    dispatch({ type: 'PLATFORM_WEB_PUBLICATION_FAILURE' });
                    return [2 /*return*/, { name: null, icon: null, textColor: '#828282', bgColor: '#FFFFFF' }];
            }
        });
    }); };
};
export var fetchSubdomain = function (appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var resp, object, subdomain, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'PLATFORM_WEB_SUBDOMAIN_REQUEST' });
                    return [4 /*yield*/, SubdomainService.getSubdomainName(appId)];
                case 1:
                    resp = _a.sent();
                    if (!resp) {
                        dispatch({
                            type: 'PLATFORM_WEB_SUBDOMAIN_SUCCESS',
                            subdomain: '',
                            subdomainAppId: appId,
                        });
                        return [2 /*return*/, ''];
                    }
                    object = resp.object;
                    subdomain = object.name || '';
                    dispatch({
                        type: 'PLATFORM_WEB_SUBDOMAIN_SUCCESS',
                        subdomain: subdomain,
                        subdomainAppId: appId,
                    });
                    return [2 /*return*/, subdomain];
                case 2:
                    e_3 = _a.sent();
                    console.error(e_3);
                    dispatch({ type: 'PLATFORM_WEB_SUBDOMAIN_FAILURE' });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, null];
            }
        });
    }); };
};
export var checkSubdomain = function (name) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var object, available, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'PLATFORM_WEB_SUBDOMAIN_CHECK_REQUEST' });
                return [4 /*yield*/, SubdomainService.checkSubdomainAvailability(name)];
            case 1:
                object = (_a.sent()).object;
                if (object) {
                    available = object.available;
                    dispatch({
                        type: 'PLATFORM_WEB_SUBDOMAIN_CHECK_SUCCESS',
                        available: available,
                        subdomain: name,
                    });
                    return [2 /*return*/];
                }
                return [3 /*break*/, 3];
            case 2:
                e_4 = _a.sent();
                console.error(e_4);
                return [3 /*break*/, 3];
            case 3:
                dispatch({ type: 'PLATFORM_WEB_SUBDOMAIN_CHECK_FAILURE' });
                return [2 /*return*/];
        }
    });
}); }; };
export var deleteSubdomain = function (appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'PLATFORM_WEB_SUBDOMAIN_DELETE_REQUEST' });
                return [4 /*yield*/, SubdomainService.deleteSubdomain(appId)];
            case 1:
                _a.sent();
                dispatch({ type: 'PLATFORM_WEB_SUBDOMAIN_DELETE_SUCCESS' });
                return [2 /*return*/];
            case 2:
                e_5 = _a.sent();
                console.error(e_5);
                return [3 /*break*/, 3];
            case 3:
                dispatch({ type: 'PLATFORM_WEB_SUBDOMAIN_DELETE_FAILURE' });
                return [2 /*return*/];
        }
    });
}); }; };
export var resetSubdomain = function () { return function (dispatch) {
    dispatch({ type: 'PLATFORM_WEB_SUBDOMAIN_CHECK_RESET' });
}; };
export var createSubdomain = function (appId, name) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var e_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'PLATFORM_WEB_SUBDOMAIN_REQUEST' });
                    return [4 /*yield*/, SubdomainService.createSubdomain(appId, name)];
                case 1:
                    _a.sent();
                    dispatch({ type: 'PLATFORM_WEB_SUBDOMAIN_SUCCESS', subdomain: name });
                    return [2 /*return*/];
                case 2:
                    e_6 = _a.sent();
                    console.error(e_6);
                    return [3 /*break*/, 3];
                case 3:
                    dispatch({ type: 'PLATFORM_WEB_SUBDOMAIN_FAILURE' });
                    return [2 /*return*/];
            }
        });
    }); };
};
export var hasFirebaseSecret = function (appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, object, projectId, e_7;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    dispatch({ type: 'ACCOUNTS_FIREBASE_HAS_SECRET_REQUEST' });
                    return [4 /*yield*/, AccountsService.hasSecret(appId, 'firebase')];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, AccountsService.getFirebaseProjectId(appId)];
                case 2:
                    _a = (_b.sent()).object, object = _a === void 0 ? {} : _a;
                    projectId = void 0;
                    if (object.project_id) {
                        projectId = object.project_id;
                    }
                    dispatch({ type: 'ACCOUNTS_FIREBASE_HAS_SECRET_SUCCESS', projectId: projectId });
                    return [3 /*break*/, 4];
                case 3:
                    e_7 = _b.sent();
                    console.error(e_7);
                    dispatch({ type: 'ACCOUNTS_FIREBASE_HAS_SECRET_FAILURE' });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveFirebaseSecret = function (appId, file) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var e_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'ACCOUNTS_FIREBASE_SAVE_SECRET_REQUEST' });
                    return [4 /*yield*/, AccountsService.saveSecret(appId, {
                            account_secret_type: 'firebase',
                            secret_key: file,
                        })];
                case 1:
                    _a.sent();
                    dispatch({ type: 'ACCOUNTS_FIREBASE_SAVE_SECRET_SUCCESS' });
                    return [3 /*break*/, 3];
                case 2:
                    e_8 = _a.sent();
                    console.error(e_8);
                    dispatch({ type: 'ACCOUNTS_FIREBASE_SAVE_SECRET_FAILURE' });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var getCertificateDetails = function (appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var objects, e_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'CERTIFICATE_DETAILS_REQUEST' });
                    return [4 /*yield*/, AccountsService.getCertificateDetails(appId)];
                case 1:
                    objects = (_a.sent()).objects;
                    dispatch({
                        type: 'CERTIFICATE_DETAILS_SUCCESS',
                        certificateDetails: objects,
                    });
                    return [2 /*return*/, objects];
                case 2:
                    e_9 = _a.sent();
                    console.error(e_9);
                    dispatch({ type: 'CERTIFICATE_DETAILS_FAILURE' });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var checkFirebaseAndroidApp = function (appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var object, android_bundle_id, e_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'ACCOUNTS_FIREBASE_APP_CHECK_REQUEST' });
                    return [4 /*yield*/, AccountsService.checkAndroid(appId)];
                case 1:
                    object = (_a.sent()).object;
                    if (object) {
                        android_bundle_id = object.android_bundle_id;
                        dispatch({
                            type: 'ACCOUNTS_FIREBASE_APP_CHECK_SUCCESS',
                            androidBundleId: android_bundle_id,
                            androidBundleCheckAppId: appId,
                        });
                        return [2 /*return*/, android_bundle_id];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_10 = _a.sent();
                    console.error(e_10);
                    if ((e_10.status && e_10.status === 404) || e_10 instanceof SyntaxError) {
                        dispatch({
                            type: 'ACCOUNTS_FIREBASE_APP_CHECK_SUCCESS',
                            androidBundleCheckAppId: appId,
                        });
                        return [2 /*return*/, ''];
                    }
                    return [3 /*break*/, 3];
                case 3:
                    dispatch({ type: 'ACCOUNTS_FIREBASE_APP_CHECK_FAILURE' });
                    return [2 /*return*/, ''];
            }
        });
    }); };
};
export var setupFirebaseAndroidApp = function (appId, secret) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var response, blob, e_11;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch({ type: 'ACCOUNTS_FIREBASE_APP_SETUP_REQUEST' });
                    return [4 /*yield*/, AccountsService.setupAndroid(appId, secret.androidBundleId, secret.key_alias, secret.key_password)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.blob()];
                case 2:
                    blob = _a.sent();
                    saveAs(blob, 'certificate.p12');
                    dispatch({
                        type: 'ACCOUNTS_FIREBASE_APP_SETUP_SUCCESS',
                        androidBundleId: secret.androidBundleId,
                    });
                    return [2 /*return*/, true];
                case 3:
                    e_11 = _a.sent();
                    console.error(e_11);
                    dispatch({ type: 'ACCOUNTS_FIREBASE_APP_SETUP_FAILURE' });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, false];
            }
        });
    }); };
};
export var hasAppStoreConnectSecret = function (appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var e_12;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'ACCOUNTS_APP_STORE_CONNECT_HAS_SECRET_REQUEST' });
                    return [4 /*yield*/, AccountsService.hasSecret(appId, 'app_store_connect')];
                case 1:
                    _a.sent();
                    dispatch({ type: 'ACCOUNTS_APP_STORE_CONNECT_HAS_SECRET_SUCCESS' });
                    return [3 /*break*/, 3];
                case 2:
                    e_12 = _a.sent();
                    console.error(e_12);
                    dispatch({ type: 'ACCOUNTS_APP_STORE_CONNECT_HAS_SECRET_FAILURE' });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var saveAppStoreConnectSecret = function (appId, secret) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var e_13;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch({ type: 'ACCOUNTS_APP_STORE_CONNECT_SAVE_SECRET_REQUEST' });
                    if (!secret.file) return [3 /*break*/, 2];
                    return [4 /*yield*/, AccountsService.saveSecret(appId, {
                            account_secret_type: 'app_store_connect',
                            meta: { key_id: secret.key_id, issuer_id: secret.issuer_id },
                            secret_key: secret.file,
                        })];
                case 1:
                    _a.sent();
                    dispatch({ type: 'ACCOUNTS_APP_STORE_CONNECT_SAVE_SECRET_SUCCESS' });
                    return [2 /*return*/];
                case 2: return [3 /*break*/, 4];
                case 3:
                    e_13 = _a.sent();
                    console.error(e_13);
                    return [3 /*break*/, 4];
                case 4:
                    dispatch({ type: 'ACCOUNTS_APP_STORE_CONNECT_SAVE_SECRET_FAILURE' });
                    return [2 /*return*/];
            }
        });
    }); };
};
export var checkFirebaseIOSApp = function (appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var object, ios_bundle_id, project_id, ios_team_id, e_14;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'ACCOUNTS_FIREBASE_IOS_APP_CHECK_REQUEST' });
                    return [4 /*yield*/, AccountsService.checkIOS(appId)];
                case 1:
                    object = (_a.sent()).object;
                    if (object) {
                        ios_bundle_id = object.ios_bundle_id, project_id = object.project_id, ios_team_id = object.ios_team_id;
                        dispatch({
                            type: 'ACCOUNTS_FIREBASE_IOS_APP_CHECK_SUCCESS',
                            iosBundleId: ios_bundle_id,
                            projectID: project_id,
                            teamId: ios_team_id,
                            iosBundleCheckAppId: appId,
                        });
                        return [2 /*return*/, { ios_bundle_id: ios_bundle_id, ios_team_id: ios_team_id }];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_14 = _a.sent();
                    console.error(e_14);
                    if ((e_14.status && e_14.status === 404) || e_14 instanceof SyntaxError) {
                        dispatch({
                            type: 'ACCOUNTS_FIREBASE_IOS_APP_CHECK_SUCCESS',
                            iosBundleCheckAppId: appId,
                        });
                        return [2 /*return*/, {}];
                    }
                    return [3 /*break*/, 3];
                case 3:
                    dispatch({ type: 'ACCOUNTS_FIREBASE_IOS_APP_CHECK_FAILURE' });
                    return [2 /*return*/, ''];
            }
        });
    }); };
};
export var setupFirebaseIOSApp = function (appId, bundleId, teamId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var e_15;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'ACCOUNTS_FIREBASE_IOS_APP_SETUP_REQUEST' });
                    return [4 /*yield*/, AccountsService.setupIOS(appId, bundleId, teamId)];
                case 1:
                    _a.sent();
                    dispatch({
                        type: 'ACCOUNTS_FIREBASE_IOS_APP_SETUP_SUCCESS',
                        iosBundleId: bundleId,
                    });
                    return [2 /*return*/, true];
                case 2:
                    e_15 = _a.sent();
                    console.error(e_15);
                    dispatch({ type: 'ACCOUNTS_FIREBASE_IOS_APP_SETUP_FAILURE' });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, false];
            }
        });
    }); };
};
export var checkAndroidPubCert = function (appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var e_16;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'ACCOUNTS_ANDROID_PUB_CERT_REQUEST' });
                    return [4 /*yield*/, AccountsService.hasSecret(appId, 'android_pub_cert')];
                case 1:
                    _a.sent();
                    dispatch({
                        type: 'ACCOUNTS_ANDROID_PUB_CERT_SUCCESS',
                    });
                    return [2 /*return*/, true];
                case 2:
                    e_16 = _a.sent();
                    console.error(e_16);
                    dispatch({ type: 'ACCOUNTS_ANDROID_PUB_CERT_CHECK_FAILURE' });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/, false];
            }
        });
    }); };
};
export var downloadAndroidPubCert = function (appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var response, blob, e_17;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch({ type: 'ACCOUNTS_ANDROID_PUB_CERT_DOWNLOAD_REQUEST' });
                    return [4 /*yield*/, AccountsService.downloadAndroidPubCert(appId)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.blob()];
                case 2:
                    blob = _a.sent();
                    saveAs(blob, 'certificate.p12');
                    return [2 /*return*/, true];
                case 3:
                    e_17 = _a.sent();
                    console.error(e_17);
                    dispatch({ type: 'ACCOUNTS_ANDROID_PUB_CERT_DOWNLOAD_FAILURE' });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, false];
            }
        });
    }); };
};
export var saveAndroidPubCert = function (appId, secret) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var e_18;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch({ type: 'ACCOUNTS_ANDROID_PUB_CERT_REQUEST' });
                    if (!secret.publish_cert) return [3 /*break*/, 2];
                    return [4 /*yield*/, AccountsService.saveSecret(appId, {
                            account_secret_type: 'android_pub_cert',
                            meta: {
                                key_alias: secret.key_alias,
                                key_password: secret.key_password,
                            },
                            secret_key: secret.publish_cert,
                        })];
                case 1:
                    _a.sent();
                    dispatch({ type: 'ACCOUNTS_ANDROID_PUB_CERT_SUCCESS' });
                    return [2 /*return*/];
                case 2: return [3 /*break*/, 4];
                case 3:
                    e_18 = _a.sent();
                    console.error(e_18);
                    return [3 /*break*/, 4];
                case 4:
                    dispatch({ type: 'ACCOUNTS_ANDROID_PUB_CERT_FAILURE' });
                    return [2 /*return*/];
            }
        });
    }); };
};
export var hasIosAppStoreConfig = function (appId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var e_19;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({ type: 'ACCOUNTS_HAS_APP_STORE_CONFIG_REQUEST' });
                    return [4 /*yield*/, AccountsService.hasIosAppStoreConfig(appId)];
                case 1:
                    _a.sent();
                    dispatch({ type: 'ACCOUNTS_HAS_APP_STORE_CONFIG_SUCCESS' });
                    return [2 /*return*/, true];
                case 2:
                    e_19 = _a.sent();
                    console.error(e_19);
                    dispatch({ type: 'ACCOUNTS_HAS_APP_STORE_CONFIG_FAILURE' });
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var saveIosAppStoreConfig = function (appId, config) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var appProvisioningName, notificationProvisioningName, e_20;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    dispatch({ type: 'ACCOUNTS_APP_STORE_CONFIG_REQUEST' });
                    if (!config.ios_provisioning_profile) {
                        dispatch({ type: 'ACCOUNTS_APP_STORE_CONFIG_FAILURE' });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, getNameFromProvisioningProfile(config.ios_provisioning_profile)];
                case 1:
                    appProvisioningName = _b.sent();
                    if (!config.ios_provisioning_profile_notification) {
                        dispatch({ type: 'ACCOUNTS_APP_STORE_CONFIG_FAILURE' });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, getNameFromProvisioningProfile(config.ios_provisioning_profile_notification)];
                case 2:
                    notificationProvisioningName = _b.sent();
                    return [4 /*yield*/, AccountsService.saveIosAppStoreConfig(appId, config, {
                            app: appProvisioningName,
                            notification: notificationProvisioningName,
                        })];
                case 3:
                    _b.sent();
                    dispatch({ type: 'ACCOUNTS_APP_STORE_CONFIG_SUCCESS' });
                    return [2 /*return*/, { success: true }];
                case 4:
                    e_20 = _b.sent();
                    dispatch({ type: 'ACCOUNTS_APP_STORE_CONFIG_FAILURE' });
                    return [2 /*return*/, {
                            success: false,
                            message: (_a = e_20 === null || e_20 === void 0 ? void 0 : e_20.errorFromEP) === null || _a === void 0 ? void 0 : _a.message,
                        }];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
export var getOrgActiveBundlesForPlatform = function (appId, platform) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, bundles, styles_meta, err_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                dispatch({ type: 'LOAD_AVAILABLE_BUNDLE_REQUEST' });
                return [4 /*yield*/, BundleService.listActiveOrgBundlesForPlatform(appId, platform)];
            case 1:
                _a = _b.sent(), bundles = _a.objects, styles_meta = _a.meta;
                dispatch({
                    type: 'LOAD_AVAILABLE_BUNDLE_SUCCESS',
                    bundles: bundles,
                    styles_meta: styles_meta,
                });
                return [2 /*return*/, bundles];
            case 2:
                err_1 = _b.sent();
                dispatch({ type: 'LOAD_AVAILABLE_BUNDLE_FAILURE', err: err_1 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var createLicense = function (appId, platform) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var e_21;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'CREATE_LICENSE_REQUEST' });
                return [4 /*yield*/, BundleService.createLicense(appId, platform)];
            case 1:
                _a.sent();
                dispatch({ type: 'CREATE_LICENSE_SUCCESS' });
                return [2 /*return*/, true];
            case 2:
                e_21 = _a.sent();
                console.error(e_21);
                dispatch({ type: 'CREATE_LICENSE_FAILURE' });
                return [2 /*return*/, false];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var hasLicense = function (appId, platform) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var e_22;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'HAS_LICENSE_REQUEST' });
                return [4 /*yield*/, BundleService.hasLicense(appId, platform)];
            case 1:
                _a.sent();
                dispatch({ type: 'HAS_LICENSE_SUCCESS' });
                return [2 /*return*/, true];
            case 2:
                e_22 = _a.sent();
                console.error(e_22);
                dispatch({ type: 'HAS_LICENSE_FAILURE' });
                return [2 /*return*/, false];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var revokeLicense = function (appId, platform) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var e_23;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'REVOKE_LICENSE_REQUEST' });
                return [4 /*yield*/, BundleService.revokeLicense(appId, platform)];
            case 1:
                _a.sent();
                dispatch({ type: 'REVOKE_LICENSE_SUCCESS' });
                return [2 /*return*/, true];
            case 2:
                e_23 = _a.sent();
                console.error(e_23);
                dispatch({ type: 'REVOKE_LICENSE_FAILURE' });
                return [2 /*return*/, false];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var getLicense = function (appId, platform) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var bundle, e_24;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: 'GET_LICENSE_REQUEST' });
                return [4 /*yield*/, BundleService.getLicense(appId, platform)];
            case 1:
                bundle = (_a.sent()).object;
                dispatch({ type: 'GET_LICENSE_SUCCESS', bundle: bundle, platform: platform });
                return [2 /*return*/, bundle];
            case 2:
                e_24 = _a.sent();
                console.error(e_24);
                dispatch({ type: 'GET_LICENSE_FAILURE', error: e_24, platform: platform });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
